var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:['form-field', { disabled: _vm.disabled }],style:(_vm.blockStyle)},[(_vm.label)?_c('label',{staticClass:"title"},[_vm._v(_vm._s(_vm.label))]):_vm._e(),_c('div',{style:(_vm.fieldStyle)},[_c('div',{staticClass:"form-field-input op-textfield"},[_c('div',{staticClass:"readonly-field"},[_vm._v(" "+_vm._s(_vm.text)+" ")])])])])
}
var staticRenderFns = []

export { render, staticRenderFns }